import { render, staticRenderFns } from "./NotificationPopUp.vue?vue&type=template&id=e0a31de6&scoped=true"
import script from "./NotificationPopUp.vue?vue&type=script&lang=js"
export * from "./NotificationPopUp.vue?vue&type=script&lang=js"
import style0 from "./NotificationPopUp.vue?vue&type=style&index=0&id=e0a31de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a31de6",
  null
  
)

export default component.exports